import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "main-content" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "checkbox" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "select" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { value: "" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "select" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { value: "" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 2,
  class: "prepared"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "action" }
const _hoisted_26 = { class: "message" }
const _hoisted_27 = { class: "text" }
const _hoisted_28 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ValidationAnnotationsTable = _resolveComponent("ValidationAnnotationsTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (_ctx.template.name !== '')
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, [
            _cache[18] || (_cache[18] = _createTextVNode(" PDFテンプレート: ", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.template.name), 1)
          ]))
        : (_openBlock(), _createElementBlock("h1", _hoisted_3, "PDFテンプレート")),
      _createVNode(_component_Snackbar, { option: _ctx.snackbar }, null, 8, ["option"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[19] || (_cache[19] = _createElementVNode("th", null, "ファイル名", -1)),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "field",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.template.name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.template.name]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[22] || (_cache[22] = _createElementVNode("th", null, "設定", -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.template.setting['enable-page-break']) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.template.setting['enable-page-break']]
                      ]),
                      _cache[20] || (_cache[20] = _createElementVNode("span", null, "ページ分割", -1))
                    ]),
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.template.setting['kintone_data']) = $event)),
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleKintoneDataChange && _ctx.handleKintoneDataChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.template.setting['kintone_data']]
                      ]),
                      _cache[21] || (_cache[21] = _createElementVNode("span", null, "kintoneデータ設定", -1))
                    ])
                  ])
                ])
              ]),
              (_ctx.template.setting['kintone_data'] && !_ctx.isLoadingGetKinTonApp)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _cache[23] || (_cache[23] = _createElementVNode("th", null, "キントーンアプリ", -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.kinTonAppId) = $event)),
                          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleChangeKinToneApp && _ctx.handleChangeKinToneApp(...args))),
                          disabled: _ctx.isLoadingGetKinTonApp
                        }, [
                          _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.isLoadingGetKinTonApp ? 'Loading ...' : '1つ選択してください'), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kinToneAppData, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: item.appId
                            }, _toDisplayString(item.name), 9, _hoisted_11))
                          }), 128))
                        ], 40, _hoisted_9), [
                          [_vModelSelect, _ctx.kinTonAppId]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.template.setting['kintone_data'] && !_ctx.isLoadingGetKinTonApp)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _cache[24] || (_cache[24] = _createElementVNode("th", null, "キントーンフィールド", -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.kinToneFieldKey) = $event)),
                          disabled: !_ctx.kinTonAppId || _ctx.isLoadingGetKinTonField
                        }, [
                          _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.isLoadingGetKinTonField ? 'Loading ...' : '1つ選択してください'), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kinToneFieldData, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_16))
                          }), 128))
                        ], 8, _hoisted_14), [
                          [_vModelSelect, _ctx.kinToneFieldKey]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _cache[25] || (_cache[25] = _createElementVNode("th", null, "PDF", -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("input", {
                    type: "file",
                    hidden: "",
                    accept: "application/pdf",
                    ref: "pdfInput",
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handelInputChange($event))),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleInputClick($event)))
                  }, null, 544),
                  _createElementVNode("div", {
                    class: "dropzone",
                    onDrop: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args))),
                    onDragover: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDragover && _ctx.handleDragover(...args))),
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openFileDialog && _ctx.openFileDialog(...args)))
                  }, [
                    (!_ctx.template.pdf && !_ctx.newPdf.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, "ここにPDFファイルをドロップまたはクリックして選択してください"))
                      : _createCommentVNode("", true),
                    (_ctx.pdfDataUri && _ctx.newPdf.name === '')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                          _createElementVNode("a", {
                            href: _ctx.pdfDataUri,
                            download: ""
                          }, "PDFをダウンロード", 8, _hoisted_19)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.newPdf.name !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("figure", null, [
                            _createVNode(_component_font_awesome_icon, { icon: "file-pdf" }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.newPdf.name), 1)
                          ]),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "minus-circle",
                            onClick: _ctx.resetPdf
                          }, null, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 32)
                ])
              ]),
              (_ctx.edit && _ctx.template.created)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _cache[26] || (_cache[26] = _createElementVNode("th", null, "作成日", -1)),
                    _createElementVNode("td", null, _toDisplayString(new Date(_ctx.template.created).toLocaleString()), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.edit && _ctx.template.updated)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _cache[27] || (_cache[27] = _createElementVNode("th", null, "更新日時", -1)),
                    _createElementVNode("td", null, _toDisplayString(new Date(_ctx.template.updated).toLocaleString()), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("nav", null, [
            (!_ctx.edit)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-secondary",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
                  disabled: _ctx.isAdding
                }, [
                  (_ctx.isAdding)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: "spinner",
                        spin: "",
                        class: "me-2"
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isAdding ? 'Adding...' : '追加'), 1)
                ], 8, _hoisted_23))
              : _createCommentVNode("", true),
            (_ctx.edit)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-secondary",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
                  disabled: _ctx.isUpdating
                }, [
                  (_ctx.isUpdating)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: "spinner",
                        spin: "",
                        class: "me-2"
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isUpdating ? 'Updating...' : 'アップデート'), 1)
                ], 8, _hoisted_24))
              : _createCommentVNode("", true),
            (_ctx.edit)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-danger",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
                }, "消去"))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "notice-block" }, [
          _createElementVNode("h3", { class: "notice-title" }, "【使用上の注意事項】"),
          _createElementVNode("p", { class: "notice-description" }, [
            _createTextVNode(" ここでのチェックはonboardの帳票テンプレートPDFファイルの注釈設定の正しさを必ず保証するものではありません。"),
            _createElementVNode("br"),
            _createTextVNode(" 現在、注釈設定のうち確認が出来るのは以下の内容です。 ")
          ]),
          _createElementVNode("ul", { class: "notice-list" }, [
            _createElementVNode("li", null, "項目名の重複"),
            _createElementVNode("li", null, "表示順の重複"),
            _createElementVNode("li", null, "半角の「」」のチェック"),
            _createElementVNode("li", null, "全角の「＝」、「＠」、「＃」、「＊」のチェック"),
            _createElementVNode("li", null, "改行のチェック")
          ])
        ], -1))
      ]),
      (_ctx.validationResult.errors.length)
        ? (_openBlock(), _createBlock(_component_ValidationAnnotationsTable, {
            key: 2,
            "validation-errors": _ctx.validationResult.errors,
            annotations: _ctx.template.annotations,
            "total-items": _ctx.validationResult.totalAnnotations,
            "error-count": _ctx.validationResult.totalErrors
          }, null, 8, ["validation-errors", "annotations", "total-items", "error-count"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      ref: "remove",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[29] || (_cache[29] = _createElementVNode("h4", { class: "title" }, "確認する", -1)),
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "message" }, [
          _createElementVNode("p", { class: "text" }, "本当にこのプロフィールを削除しますか?")
        ], -1)),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.removeCancel && _ctx.removeCancel(...args)))
          }, "キャンセル"),
          _createElementVNode("button", {
            class: "btn btn-danger",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.removeConfirmed && _ctx.removeConfirmed(...args)))
          }, "消去")
        ])
      ]),
      _: 1,
      __: [29,30]
    }, 512),
    _createVNode(_component_Dialog, {
      ref: "error",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[31] || (_cache[31] = _createElementVNode("h4", { class: "title" }, "Error", -1)),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.error.message), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.errorClose && _ctx.errorClose(...args)))
          }, "Close")
        ])
      ]),
      _: 1,
      __: [31]
    }, 512)
  ], 64))
}